import styled from 'styled-components';
import { theme, toRem } from '../../styles';

export const StyledSection = styled.div`
  .mobile-number-container {
    display: grid;
    row-gap: ${toRem(32)};
    column-gap: ${toRem(16)};
    grid-template-columns: repeat(10, 1fr);
    grid-template-rows: 60px;

    .left-side {
      grid-column: 1/6;
    }
    .right-side {
      grid-column: 6/11;
    }
  }

  .optoutmsg-container {
    margin: 0 0 ${toRem(32)};
    .text-field {
      font-size: ${theme.fonts.fontS};
      color: ${theme.colors['base-10']};
      line-height: ${theme.fonts.lineHeightM};
      & a {
        text-decoration: underline;
      }
    }
  }

  .tnc-container {
    margin: ${toRem(18)} 0 ${toRem(8)};
    &.with-larger-margin-top {
      margin-top: ${toRem(36)};
    }
    .text-field {
      font-size: ${theme.fonts.fontS};
      color: ${theme.colors['base-10']};
      line-height: ${theme.fonts.lineHeightM};
    }
    .ctaLink {
      font-size: ${theme.fonts.fontS};
      color: ${theme.colors['base-10']};
      line-height: ${theme.fonts.lineHeightM};
      background-color: ${theme.colors.white};
      margin-left: ${toRem(10)};
      padding: 0;
      border-bottom: ${toRem(1)} solid ${theme.colors['base-10']};
    }
    .ctaLink:focus-visible {
      border: 2px solid ${theme.colors['base-10']};
      border-radius: ${toRem(4)};
      padding: ${toRem(1)};
    }
  }

  .user-phone-tnc-container {
    margin: ${toRem(8)} 0 0;
    .text-field {
      color: ${theme.colors['dark-gray-3']};
      font-size: ${toRem(12)};
      line-height: ${toRem(18)};
      font-weight: ${theme.fonts['fontWeightRegular']};
    }
    .ctaLink {
      color: ${theme.colors['dark-gray-3']} !important;
      border-bottom: ${toRem(1)} solid ${theme.colors['dark-gray-3']} !important;
      font-size: ${toRem(12)} !important;
      line-height: ${toRem(18)} !important;
      font-weight: ${theme.fonts['fontWeightMedium']} !important;
    }
  }

  &.user-mobile-number {
    grid-column: 1/11;
    width: 50%;
  }

  .user-mobile-number-container {
    display: grid;
    row-gap: ${toRem(32)};
    grid-template-columns: repeat(10, 1fr);
    .left-side {
      grid-column: 1/4 !important;
    }
    .right-side {
      grid-column: 4/11 !important;
    }
  }

  .outlined {
    border: ${theme.colors['dark-gray-3']} solid ${toRem(1)};
    border-radius: ${toRem(4)};
    position: relative;
    margin-top: ${toRem(12)};

    &:focus {
      border: ${theme.colors['base-10']} solid ${toRem(3)};
    }

    &.is-error {
      border: var(--t-form-error-color) solid ${toRem(1)} !important;
      .outlined-label {
        color: var(--t-form-error-color);
      }
    }

    &:focus-within > .outlined-label {
      color: ${theme.colors['base-10']};
    }

    &:focus-within {
      border: ${theme.colors['dark-gray-2']} solid ${toRem(3)};
    }
  }

  .outlined-label {
    width: auto;
    margin: 0;
    padding: ${toRem(6)};
    position: absolute;
    top: ${toRem(-15)};
    inset-inline-start: ${toRem(12)};
    background-color: ${theme.colors.white};
    font-size: ${theme.fonts['fontS']};
    color: ${theme.colors['dark-gray-3']};
    line-height: ${theme.fonts['lineHeightXs']};
    font-weight: ${theme.fonts['fontWeightMedium']};
  }

  @media ${theme.mediaQuery.desktop}, ${theme.mediaQuery.allTablets} {
    &.r0-mobile-container {
      .user-mobile-number-container .left-side {
        grid-column: 1 / 3 !important;
      }

      .user-mobile-number-container .right-side {
        grid-column: 3 / 11 !important;
      }
    }
  }

  @media ${theme.mediaQuery.allTablets} {
    &.user-mobile-number {
      .user-mobile-number-container {
        display: grid;
        grid-template-rows: auto !important;
        .left-side {
          grid-column: 1/5 !important;
        }
        .right-side {
          grid-column: 5/11 !important;
        }
      }
    }
  }

  @media ${theme.mediaQuery.allMobiles} {
    .mobile-number-container {
      display: grid;
      grid-template-columns: 1fr;
      column-gap: 0;
      grid-template-rows: repeat(2, 60px);

      .left-side {
        grid-column: 1/10;
      }
      .right-side {
        grid-column: 1/10;
      }
    }
    .user-mobile-number-container {
      display: grid;
      grid-template-rows: auto !important;
      .left-side {
        grid-column: 1/5 !important;
      }
      .right-side {
        grid-column: 5/11 !important;
      }
    }
    &.user-mobile-number {
      width: 100% !important;
    }
  }
`;

export const StyledModalDiv = styled.div`
  &.modal-description {
    padding: ${toRem(32)};
    background-color: ${theme.colors.white};
    line-height: ${theme.fonts.lineHeightXl};
    border-radius: 0 0 ${toRem(14)} ${toRem(14)};
  }
  a {
    text-decoration: underline;
  }
`;

export const StyledError = styled.p`
  margin: ${toRem(4)} 0 0;
  color: ${theme.colors.monza};
  font-size: ${theme.fonts['fontXs']};
  line-height: ${theme.fonts['lineHeightXs']};

  &.icon-information::before {
    margin-right: ${toRem(9.3)};
  }
  &.information {
    margin-left: ${toRem(16)};
  }
`;
